<template>
  <div>
    <h3 v-if="!iscom">每日投一投</h3>
    <el-form :inline="true" class="demo-form-inline" :loading="loading" size="mini">
      <el-form-item label="甲方ID">
        <el-input placeholder="甲方ID" v-model="filter.partyA"></el-input>
      </el-form-item>
      <el-form-item label="投递编号">
        <el-input placeholder="投递编号" v-model="filter.quotationId"></el-input>
      </el-form-item>
      <el-form-item label="工作编号">
        <el-input placeholder="工作编号" v-model="filter.jobId"></el-input>
      </el-form-item>
      <el-form-item label="工作方式">
        <el-select v-model="filter.chargingWay">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(label, key) in chargingWay" :key="key" :label="label" :value="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="fetch(1)">查询</el-button>
        <el-button type="primary" size="mini" @click="rest()">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini">
      <el-table-column prop="id" label="序号" width="50"></el-table-column>
      <el-table-column prop="partyA" label="甲方ID"></el-table-column>
      <el-table-column prop="partyAName" label="甲方昵称"></el-table-column>
      <el-table-column prop="quotationId" label="投递编号"></el-table-column>
      <el-table-column prop="jobId" label="工作编号"></el-table-column>
      <el-table-column prop="title" label="工作简介"></el-table-column>
      <el-table-column prop="status" label="工作方式">
        <template slot-scope="scope">{{
          chargingWay[scope.row.chargingWay]
        }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="使用时间"></el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination background layout="prev, pager, next" :page-size="limit" @current-change="(i) => (pageNum = i)"
        :page-count="pageNum" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import map from "../../../datamap";
import api from "../../api";
// import newApi from "@/newApi/bean.js";

let { prop } = api;
export default {
  name: "partyBorder",
  props: {
    iscom: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    eqId: {
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      map,
      loading: true,
      types: {},
      filter: {
        quotationId: "",
        type: 0,
        jobId: '',
        chargingWay: '',
      },
      list: [],
      total: 0,
      pageNum: 1,
      limit: 30,
      chargingWay: {
        0: "按小时计费",
        1: "项目制",
      },
    };
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  methods: {
    rest() {
      this.filter = {
        quotationId: "",
        type: 0,
        jobId: '',
        partyA: '',
        chargingWay: '',
      }
    },
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      this.filter.type = this.iscom ? 1 : 0
      this.filter.eqId = this.eqId ? this.eqId : null

      this.filter.pageNum = this.pageNum
      this.filter.limit = this.limit
      let res = await prop.qryDeliverLog(this.filter);
      this.list = res.data.data;
      this.total = res.data.pageinfo.totalCount;
    },
    async getTypes() {
      let res = await bean.types();
      this.types = res.data.data;
    },

  },
  mounted() {
    this.fetch(1);
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/views/prop/partyB/daily.vue